/* eslint-disable no-await-in-loop */
import type {AppDispatch} from 'stores/redux_store';
import {getMyChannelMember as fetchMyChannelMember} from 'mattermost-redux/actions/channels';
import {getMyChannelMember} from 'mattermost-redux/selectors/entities/channels';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/common';
import {completePostReceive} from 'actions/new_post';
import {loadNewDMIfNeeded, loadNewGMIfNeeded} from 'actions/user_actions';
import {handleNewPosts as handleNewPostsForSidebar} from 'features/sidebar/actions/handle_new_post';
import {type PostWithMeta} from 'features/posts/types/posted_event';
import {ChannelType, type DirectChannel} from '@mattermost/types/channels';
import {type ActionFunc} from 'mattermost-redux/types/actions';
import {type Post} from '@mattermost/types/posts';
import {getUserIdFromChannelName} from 'mattermost-redux/utils/channel_utils';
import {fetchUsersByIds} from 'features/users/actions/fetch_users_by_ids';

export const handleNewPosts = (payload: PostWithMeta[]): ActionFunc => {
    return async (doDispatch, getState) => {
        const dispatch = doDispatch as AppDispatch;
        const state = getState();
        const currentUserId = getCurrentUserId(state);
        const posts: Post[] = [];

        for (const {post, meta} of payload) {
            posts.push(post);

            const myChannelMember = getMyChannelMember(state, post.channel_id);
            const hasMyChannelMember = myChannelMember?.user_id === currentUserId;
            let isMyMemberFetched = false;

            if (!hasMyChannelMember) {
                await dispatch(fetchMyChannelMember(post.channel_id));
                isMyMemberFetched = true;
            }

            await dispatch(completePostReceive(post, meta, !hasMyChannelMember));

            if (meta.channel_type === ChannelType.Direct) {
                const teammateId = getUserIdFromChannelName(currentUserId, meta.channel_name as DirectChannel['name']);

                await dispatch(fetchUsersByIds({userIds: [teammateId]}));
                await dispatch(loadNewDMIfNeeded(post.channel_id, isMyMemberFetched));
            }

            if (meta.channel_type === ChannelType.Group) {
                await dispatch(loadNewGMIfNeeded(post.channel_id, isMyMemberFetched));
            }
        }

        await dispatch(handleNewPostsForSidebar(posts));

        return {data: true};
    };
};
